"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNREPEATABLE_EVENTS = exports.ONLY_ONCE_EVENTS = exports.EVENT_NAMES = void 0;
exports.EVENT_NAMES = [
    // App
    'app_close',
    // Data loading / Player buffering
    'buffering_start',
    'buffering_stop',
    // Heartbeat
    'heartbeat_5',
    // Playback
    'playback_10',
    'playback_25',
    'playback_50',
    'playback_75',
    'playback_90',
    'playback_pause',
    'playback_start',
    'playback_stop',
    // Player
    'player_close',
    'player_open',
    // Scenes
    'scene_view',
    // Scrolling in scene
    'scroll_25',
    'scroll_50',
    'scroll_75',
    'scroll_90',
    'scroll',
];
exports.ONLY_ONCE_EVENTS = [
    // Playback
    'playback_10',
    'playback_25',
    'playback_50',
    'playback_75',
    'playback_90',
    // Scrolling in scene
    'scroll_25',
    'scroll_50',
    'scroll_75',
    'scroll_90',
    'scroll',
];
exports.UNREPEATABLE_EVENTS = [
    // Scenes
    'scene_view',
    // Player
    'player_open',
    // Playback
    'playback_start',
    'playback_pause',
    'playback_stop',
    // Data loading / Player buffering
    'buffering_start',
    'buffering_stop',
];
